export default __webpack_public_path__ + "static/media/apple-pay.c05c5dbb.png";